'use client';
import { createStyles, rem } from '@s7/styles';
import { isString, isFunction } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const rootSizes = {
    xl1: 48,
    lg1: 40,
    md1: 32,
    sm1: 28,
    xs1: 20
};
/**
 * Массив размеров иконок.
 * Каждый элемент представляет собой кортеж, где первый элемент описывает максимальный размер rootSize,
 * а второй элемент - фиксированный размер иконки или функция для расчета размера иконки.
 */ const iconSizes = [
    [
        48,
        (rootSize)=>rootSize / 2
    ],
    [
        80,
        24
    ],
    [
        90,
        28
    ],
    [
        Infinity,
        32
    ]
];
/**
 * Массив размеров границ.
 * Каждый элемент представляет собой кортеж, где первый элемент описывает максимальный размер rootSize,
 * второй - ширину outsideBorder, третий - ширину insideBorder.
 */ const bordersSizes = [
    [
        23,
        1,
        1
    ],
    [
        39,
        1,
        2
    ],
    [
        47,
        2,
        2
    ],
    [
        64,
        2,
        3
    ],
    [
        119,
        2,
        4
    ],
    [
        Infinity,
        3,
        5
    ]
];
/**
 * Массив размеров шрифтов.
 * Каждый элемент представляет собой кортеж, где первый элемент описывает максимальный размер rootSize,
 * второй - размер fontSize, третий - высоту lineHeight.
 */ const fontSizes = [
    [
        24,
        10,
        14
    ],
    [
        28,
        12,
        16
    ],
    [
        32,
        13,
        18
    ],
    [
        44,
        14,
        20
    ],
    [
        72,
        16,
        24
    ],
    [
        80,
        18,
        24
    ],
    [
        90,
        20,
        28
    ],
    [
        Infinity,
        24,
        28
    ]
];
const getMatch = (rootSize, list)=>{
    return list.find((cond)=>rootSize <= cond[0]) || list[list.length - 1];
};
const getDimensions = (rootSize)=>{
    const iconMatch = getMatch(rootSize, iconSizes);
    const fontMatch = getMatch(rootSize, fontSizes);
    const borderMatch = getMatch(rootSize, bordersSizes);
    return [
        isFunction(iconMatch[1]) ? iconMatch[1](rootSize) : iconMatch[1],
        borderMatch[1],
        borderMatch[2],
        rem(fontMatch[1]),
        rem(fontMatch[2])
    ];
};
var useStyles = createStyles((theme, { color, radius, withBorders, borderColor, borderWidth, insideBorderColor, insideBorderWidth }, { size })=>{
    const rootSize = isString(size) ? rootSizes[size] : size;
    const [iconSize, defaultOutsideBorderWidth, defaultInsideBorderWidth, fontSize, lineHeight] = getDimensions(rootSize);
    const _rootSize = rem(rootSize);
    const _iconSize = rem(iconSize);
    const backgroundColor = theme.fn.primaryShade(theme.fn.themeColor(color));
    const outsideBorderColor = isString(borderColor) ? theme.fn.primaryShade(theme.fn.themeColor(borderColor)) : theme.fn.gradient(_extends({}, borderColor));
    const _insideBorderColor = theme.fn.primaryShade(theme.fn.themeColor(insideBorderColor));
    const borderRadius = theme.fn.borderRadius(radius);
    const outsideBorder = borderWidth != null ? borderWidth : defaultOutsideBorderWidth;
    const insideBorder = insideBorderWidth != null ? insideBorderWidth : defaultInsideBorderWidth;
    return {
        root: _extends({
            width: _rootSize,
            height: _rootSize,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }, withBorders && {
            background: `linear-gradient(${_insideBorderColor}, ${_insideBorderColor}) padding-box, ${outsideBorderColor} border-box`,
            border: `${rem(outsideBorder)} solid transparent`,
            padding: theme.fn.space(insideBorder),
            borderRadius
        }, {
            boxSizing: 'border-box',
            userSelect: 'none'
        }),
        body: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor,
            borderRadius
        },
        image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius
        },
        content: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            fontFamily: theme.typography.default.family,
            fontSize,
            lineHeight,
            fontWeight: 600,
            color: theme.palette.text.tertiary,
            '> svg': {
                width: _iconSize,
                height: _iconSize
            }
        }
    };
});

export { useStyles as default };
//# sourceMappingURL=Avatar.styles.js.map
